import { BudgetAPI } from "@griffingroupglobal/eslib-api";

const bulkAddLineitemsHandler = async (props) => {
  const { lineitems, budgetLastUpdated, budgetId } = props;

  const response = await BudgetAPI.postWOP(
    `${budgetId}/$bulkaddlineitems`,
    lineitems,
    {
      params: {
        lastUpdated: budgetLastUpdated,
      },
    }
  );
  return response.data;
};

export default bulkAddLineitemsHandler;
